import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Alert, PasswordInput } from '../components/UI';
import logo from '../assets/logo.jpg';

export default function Login() {
  const { login, loading } = useAuth();
  const [employeeId, setEmployeeId] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  // Set when the app signs someone out for a reason they need to know about
  // (e.g. leaving the exam tab). Cleared as soon as they try to sign in again.
  const [notice, setNotice] = useState(location.state?.notice || '');

  async function handleSubmit(e) {
    e.preventDefault();
    setError('');
    setNotice('');
    try {
      const user = await login(employeeId.trim(), password);
      const dest = location.state?.from || (user.role === 'admin' ? '/admin' : '/');
      navigate(dest, { replace: true });
    } catch (err) {
      setError(err.message || 'Login failed');
    }
  }

  return (
    <div className="login-screen">
      <div className="login-card">
        <div className="login-brand">
          <img src={logo} alt="Yashoda Hospitals" />
          <div>
            <div className="brand-name">Yashoda Hospitals</div>
            <div className="brand-sub">MCQ Analysis</div>
          </div>
        </div>
        <h1>Sign in</h1>
        <p className="sub">Yashoda Hitec City Induction Exam</p>
        <Alert type="warning">{notice}</Alert>
        <Alert type="danger">{error}</Alert>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label htmlFor="employee_id">Employee ID</label>
            <input
              id="employee_id" type="text" maxLength={30} autoComplete="username"
              placeholder="Your employee ID" value={employeeId}
              onChange={(e) => setEmployeeId(e.target.value)}
              required autoFocus
            />
          </div>
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <PasswordInput
              id="password" placeholder="Enter your password"
              value={password} onChange={(e) => setPassword(e.target.value)} required
            />
          </div>
          <button className="btn btn-primary btn-block" type="submit" disabled={loading}>
            {loading ? 'Signing in…' : 'Sign in'}
          </button>
        </form>
        {/* <div className="login-creds">
          <span className="login-creds-title">Default admin login</span>
          <span>Mobile: <strong>9999999999</strong></span>
          <span>Password: <strong>Admin@123</strong></span>
        </div> */}
      </div>
    </div>
  );
}
